module.exports = __webpack_public_path__ + "media/change_style.d2a007e3.mp4";